import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const CareersDecorator = () => (
  <>
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute left-9 top-[calc(50%-50px)] hidden h-6 w-6 rotate-180 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute left-0 top-[calc(50%+50px)] hidden h-9 w-9 rotate-[-90deg] md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute right-12 top-[calc(50%+70px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute right-0 top-[calc(50%+40px)] hidden h-6 w-6 md:block"
    />
  </>
);
